import { render, staticRenderFns } from "./IntroRoute.vue?vue&type=template&id=9935ffc6&scoped=true&"
import script from "./IntroRoute.vue?vue&type=script&lang=js&"
export * from "./IntroRoute.vue?vue&type=script&lang=js&"
import style0 from "./IntroRoute.vue?vue&type=style&index=0&id=9935ffc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9935ffc6",
  null
  
)

export default component.exports